import { defineStore } from 'pinia'
import { ref } from 'vue'

export const multipleChoiceStore = defineStore('multipleChoice', () => {
  const multipleChoice = ref<boolean>(false)
  const selectedCount = ref<number>(0)
  const selectedResources = ref<any[]>([])
  const selectFolder = ref<any[]>([])

  const setSelectedCount = () => {
    let num = selectedResources.value.length + selectFolder.value.length
    multipleChoice.value = num > 0
    selectedCount.value = num

  }
  const setselectedResources = (v: any) => {
    let index = selectedResources.value.findIndex(x => x === v)
    if (index > -1) {
      selectedResources.value.splice(index, 1)
    } else {
      selectedResources.value.push(v)
    }
    setSelectedCount()
  }
  const getSelectedResources = () => {
    return selectedResources.value
  }
  const getSelectFolder = () => {
    return selectFolder.value
  }
  const setSelectFolder = (v: any) => {
    let index = selectFolder.value.findIndex(x => x === v)
    if (index > -1) {
      selectFolder.value.splice(index, 1)
    } else {
      selectFolder.value.push(v)
    }
    setSelectedCount()
  }
  const clearSelected = () => {
    selectedResources.value = []
    selectFolder.value = []
    setSelectedCount()
  }




  return {
    multipleChoice,
    selectedCount,
    selectedResources,
    selectFolder,
    setselectedResources,
    setSelectFolder,
    clearSelected,

    getSelectedResources,
    getSelectFolder,
  }
})
